// Parse a tax-rate string like "Texas Conveyor Only 8.25%" or "7.5" or "Resale – No Sales Tax".
export const parseTaxPercent = (taxStr) => {
  if (!taxStr || taxStr.toLowerCase().includes('no sales tax')) return 0;
  const matchPercent = taxStr.match(/([\d.]+)\s*%/);
  if (matchPercent) return parseFloat(matchPercent[1]);
  const matchNum = taxStr.match(/([\d.]+)/);
  return matchNum ? parseFloat(matchNum[1]) : 0;
};

// Mirrors the live calculation in tableComponent.js so saved `grand_total`
// matches the displayed Grand Total on /new-quote.
// Uses `||` (not `??`) for the discount fallback to match the live calc:
// a line-item discount of 0 / "" falls through to the quote-level discount.
export const computeGrandTotal = ({ parts = [], installationTotal = 0, taxStr = '', defaultDiscount = 0 } = {}) => {
  const subtotal = parts.reduce((sum, item) => {
    if (!item || item.isDeleted) return sum;
    const listPrice = parseFloat(item.listPrice || 0);
    const discountValue = parseFloat(item.discount || defaultDiscount || 0);
    const qty = parseFloat(item.qty || 0);
    const actualPrice = listPrice * (1 - discountValue / 100);
    return sum + qty * actualPrice;
  }, 0);

  const install = parseFloat(installationTotal || 0) || 0;
  const taxPercent = parseTaxPercent(taxStr);
  const taxAmount = (subtotal + install) * (taxPercent / 100);
  const total = subtotal + install + taxAmount;

  return Math.round(total * 100) / 100;
};
